import type { FurnitureObject, Vec3 } from '../types';
import { validateWardrobe } from './wardrobeConfig';

const mm = (value: number) => Math.round(value * 1000) / 1000;

/** Commit a transform gizmo scale to the parametric model and cutting dimensions. */
export function scaleFurniture(item: FurnitureObject, [sx, sy, sz]: Vec3): FurnitureObject | null {
  if (![sx, sy, sz].every((factor) => Number.isFinite(factor) && factor > 0)) return null;
  const next: FurnitureObject = {
    ...item,
    width: mm(item.width * sx),
    height: mm(item.height * sy),
    depth: mm(item.depth * sz),
    slope: item.slope ? { leftHeight: mm(item.slope.leftHeight * sy), rightHeight: mm(item.slope.rightHeight * sy) } : undefined,
    sections: item.sections.map((section) => ({
      ...section,
      width: mm(section.width * sx),
      drawerDepth: section.drawerDepth === undefined ? undefined : mm(section.drawerDepth * sz),
      railHeightFromFloor: section.railHeightFromFloor === undefined ? undefined : mm(section.railHeightFromFloor * sy),
    })),
    drawers: { ...item.drawers, frontHeight: mm(item.drawers.frontHeight * sy), depth: mm(item.drawers.depth * sz) },
  };
  if (next.width < 100 || next.height < 100 || next.depth < 100 || next.panelThickness * 2 >= Math.min(next.width, next.height, next.depth)) return null;
  if (next.kind === 'wardrobe' && validateWardrobe(next)) return null;
  return next;
}
